// this module will load Finix JS API
(function(d) {
  var a = d.createElement('script'); a.type = 'text/javascript';
  a.async = true; a.id = 'finix-payments';
  a.src = 'https://js.finix.com/v/1/finix.js';
  d.getElementById('root').appendChild(a);
})(document);
